const riot = require('riot');

riot.tag2('atom-anchorify', '<span class="white-space-pre-wrap" each="{item in getItems()}"><span if="{item.type === &quot;text&quot;}">{item.text}</span><a class="hover-only-text-blue_70 text-blue_70 word-break-all" if="{item.type === &quot;url&quot;}" href="{item.url}" onclick="event.stopPropagation()" target="_blank" rel="noopener noreferrer">{item.url}</a></span>', 'atom-anchorify,[data-is="atom-anchorify"]{display:inline}', '', function(opts) {
    this.getItems = () => {
      if (opts.text === this.prevText) {
        return this.prevItems || [];
      }
      var items = [];

      if (opts.text) {

        var urlTest = /[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[\w\/:%#\$&\?~\.=\+\-\_\@]+/g;

        var matched;

        var lastIndex = 0;

        while (matched = urlTest.exec(opts.text)) {

          var text = opts.text.slice(lastIndex, matched.index)
          if (text) {
            items.push({
              type: 'text',
              text,
            });
          }

          var url = matched[0];
          items.push({
            type: 'url',
            url,
          });
          lastIndex = matched.index + url.length;
        }

        var text = opts.text.substr(lastIndex);
        if (text.trim()) {
          items.push({
            type: 'text',
            text,
          });
        }
      }
      this.prevItems = items;
      this.prevText = opts.text;
      return items;
    };
});